import { cn, createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import "./index.scss";
export interface BlockProps extends ComponentBase.Component {
  title?: React.ReactNode;
  topline?: boolean;
  nextby?: boolean;
}
export const Block = ({
  className,
  title,
  children,
  topline,
  nextby
}: BlockProps) => {
  const b = createBEM("i-block");
  return <div className={cn(b({
    topline,
    nextby
  }), className)} data-sentry-component="Block" data-sentry-source-file="index.tsx">
      <div className={b("title")}>{title}</div>
      <div className={b("content")}>{children}</div>
    </div>;
};